import { render } from "./EditParent.vue?vue&type=template&id=f8d8c98e&ts=true"
import script from "./EditParent.vue?vue&type=script&lang=ts"
export * from "./EditParent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__